import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }
const _hoisted_4 = { class: "text-base text-gray-900 break-words" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadonlyField',
  props: {
    label: {},
    value: {},
    icon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          size: "20",
          color: "grey-darken-1",
          class: "mt-0.5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.icon), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.label), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.value || '—'), 1)
    ])
  ]))
}
}

})